import { TextV2 } from '@withjoy/joykit';
import React from 'react';
import { styled } from '@withjoy/joykit';
import { ExtendedDiscount } from '@shared/components/DiscountsProvider/hotels/HotelsDiscountsProvider';
import { JoyKitThemeProvider } from '@withjoy/joykit';
import { useQueryParams } from '@shared/utils/hooks/useQueryParams';
import { AccommodationCombinedType } from '@shared/components/HotelTileCard/HotelTileCard.types';
import { RemoteFeatureFlagKeys, useIsFeatureEnabled } from '@shared/core/featureFlags';

export const SpecialRateBadge: React.FC<Readonly<{ children: React.ReactNode }>> = ({ children }) => {
  return (
    // removed event theme choices from context
    <JoyKitThemeProvider>
      <StyledBadge>
        <TextV2 typographyVariant="label2">{children}</TextV2>
      </StyledBadge>
    </JoyKitThemeProvider>
  );
};

const StyledBadge = styled.div`
  background-color: ${s => s.theme.colors.newUIBrandPrimary};
  color: ${s => s.theme.colors.white};
  border-radius: 999999px;
  padding: 4px 12px;
  box-shadow: inset 0 0 0 1px color-mix(${s => s.theme.colors.newUIBrandPrimary}, 50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  & > * {
    white-space: nowrap;
  }
`;

type DiscountExperiments = Extract<RemoteFeatureFlagKeys, 'travelHotelCouponsAccommodationItem'>;

const DiscountExperimentEnabled: React.FC<Readonly<{ control: React.ReactNode; expKey: DiscountExperiments; treatment: React.ReactNode }>> = ({ control, treatment, expKey }) => {
  const [enabled] = useIsFeatureEnabled(expKey);
  return enabled ? <>{treatment}</> : <>{control}</>;
};

interface DiscountCouponBadgeProps
  extends Readonly<{
    discount: ExtendedDiscount | undefined | null;
    originalPrice?: Maybe<string>;
    accommodationType?: AccommodationCombinedType;
  }> {}

export const DiscountCouponBadge: React.FC<DiscountCouponBadgeProps> = ({ discount, originalPrice, accommodationType }) => {
  // we're specifically testing discounts triggered by rule='atLeastSomeSavings' (https://app.amplitude.com/experiment/joylife/142907)
  const searchParams = useQueryParams();
  const showDebugView = searchParams['debug'] === 'true';
  if (accommodationType && accommodationType !== AccommodationCombinedType.Hotel) return null;

  if (!discount) return null;
  return discount.rule === 'atLeastSomeSavings' ? (
    <DiscountExperimentEnabled
      control={null}
      expKey="travelHotelCouponsAccommodationItem"
      treatment={
        <>
          <SpecialRateBadge>{discount.label}</SpecialRateBadge>
          {showDebugView && <div>{originalPrice}</div>}
        </>
      }
    />
  ) : null;
};
